<template>
  <Select :class="{ 'select-class': !showCloseIcon }" v-model="data" ref="select" :disabled="disabled" :clearable="clearable"
    :transfer="transfer" :multiple="multiple" @on-change="onChange" @on-clear="clear" @on-open-change="openChange()"
    transfer-class-name="org-select-tree" :max-tag-count="maxTagCount">
    <Option value="" label="">
      <orgTree v-model="data" @change="selectNode" isSelect="1" ref="tree" :isAll="isAll" :isTopCheck='isTopCheck' :filterable="filterable" :selectAll="selectAll"
        :multiple="multiple" :checkChild="checkChild" @getTreeData="getTreeData"></orgTree>
    </Option>
    <Option v-for="(item, i) in selectArr" :key="i" :value="item.id" v-show="false">{{ item.name }}</Option>
  </Select>
</template>
<script>
import orgTree from "@/components/commons/orgTree/orgTree";
export default {
  components: { orgTree },
  props: {
    methodType: "",//请求方式
    methodsParams:{},//请求参数
    url: '',
    value: null,
    multiple: null,//是否显示多选框
    checkChild: null,//多选时选择父级是否关联子集
    maxTagCount: {
      default: 5,
    },
    status: null,//1 在营，0 非营业
    type: null,//1 所有机构团队渠道，2所有机构团队，3所有机构渠道，4所有机构，5自定义url、请求、参数下级团队数组树
    orgId: null,
    isSelectGrandChild: null,//是否查询下下级 1、是 0、否
    isAll: null,//能否选顶级
    isTopCheck: null,//顶级禁用并且不进行勾选
    disabled: null,//禁用
    selectAll: {//多选时是否默认全选
      default: true,
    },
    transfer: {
      default: true,
    },
    showCloseIcon: {//多选是否显示清除图标
      default: true,
    },
    clearable: {//是否可以清空选项，只在单选时有效
      default: true,
    },
    filterable: {//是否可以搜索
      default: true,
    }
  },
  data() {
    return {
      data: "",
      selectArr: [],
      treeData: [],
      curName: "",
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (!newVal) {
          this.data = '';
        } else {
          this.data = this.value;
        }
      },
      immediate: true
    },
  },
  methods: {
    openChange(forceInit = false) {// forceInit 是否会重新请求接口
      let url, params;
      if (this.type == 1) {//所有机构团队渠道
        url = "/buz/organizationBase/read/tree";
        params = { source: 1, orgId: this.orgId, status: this.status };
      } else if (this.type == 2) {//所有机构/团队
        url = "/buz/organizationBase/read/tree";
        params = { source: 2, orgId: this.orgId, status: this.status };
      } else if (this.type == 3) {//所有机构渠道
        url = "/buz/organizationBase/read/orgTree";
        params = { source: 1, orgId: this.orgId, status: this.status, isSelectGrandChild: this.isSelectGrandChild };
      } else if (this.type == 4) {//所有机构
        url = "/buz/organizationBase/read/orgTree";
        params = { source: 2, orgId: this.orgId, status: this.status, isSelectGrandChild: this.isSelectGrandChild };
      } else if (this.type == 5) {//自定义url，请求方式
        url = this.url;
        params = { methodType: this.methodType,...this.methodsParams};
      } else {
        console.log("参数错误")
        return
      }
      this.$refs.tree.init(url, params, forceInit, this.type);
    },
    // 设置数据
    setData(data) {
      this.treeData = data;
      this.$refs.tree.setData(data);
      this.$nextTick(() => {
        this.$refs.select.setQuery('');
      })
    },
    getTreeData(tree, list) {
      const All = [].concat(this.selectArr, list);
      this.selectArr = Array.from(new Set(All))
      this.$emit('getTreeData', tree);
      this.selectTree = tree;
    },
    // 搜索词改变时触发
    searchKeyWord(keyWord) {
      console.log("searchKeyWord", keyWord)
      this.$nextTick(() => {
        this.$refs.tree && this.$refs.tree.searchKeyword(keyWord);
      })
    },
    clear() {
      this.data = "";
      this.$emit("input", '');
      this.$emit("change", {});
    },
    selectNode(cur, nodeArr) {
      if (this.multiple) {//多选会触发onChange不用额外 change input
        this.data = nodeArr.map((item) => {
          return item.id;
        })
        if (cur.id) {
          window.setTimeout(() => {
            this.$emit("treeClick", cur);
          }, 100)
        }

      } else if (cur.id) {
        console.log('selectNode', cur)
        this.$refs.select.hideMenu();
        if (cur.selected) {
          this.$emit("input", cur.id);
          this.$emit("change", cur);
          this.data = cur.id;
          this.curName = cur.name;
        } else {
          this.curName = '';
          this.$nextTick(() => {
            cur.selected = true;
          })
          return;
        }
      }
    },
    onChange(data) {
      if (this.multiple) {
        this.$emit("change", data);
        this.$emit("input", data);
      }
    },
    // 勾选子集 外部调用
    selectChild(id) {
      this.$refs.tree.selectChild(id);
    },
    // 根据checked状态同步选中id 外部调用
    setSelectIdByChecked() {
      this.$refs.tree.setSelectIdByChecked();
    },
  },

};
</script>
  
<style lang="scss" scoped>
.ivu-transfer {
  text-align: center;

  /deep/ .ivu-transfer-list {
    text-align: left;
  }
}

.powerModal {
  /deep/ .ivu-modal-body {
    height: 500px;
    overflow-y: auto;
  }
}

.select-class {
  /deep/.ivu-icon-ios-close {
    display: none;
  }
}</style>  